import { Box } from "@mui/material";
import spinner from "src/assets/ed/ed-spinner.png";

const EdSpinner = ({
  size = 400,
  speed = 4,
  src = spinner,
  alt = "Loading…",
}: {
  size?: number | string;
  speed?: number;
  src?: string;
  alt?: string;
}) => {
  return (
    <Box
      component="img"
      role="status"
      aria-label={alt}
      src={src}
      sx={{
        alignSelf: "center",
        width: size,
        height: size,
        display: "inline-block",
        willChange: "transform",
        animation: `spin ${speed}s linear infinite`,
        "@keyframes spin": {
          "0%": { transform: "rotate(0deg)" },
          "100%": { transform: "rotate(360deg)" },
        },
        "@media (prefers-reduced-motion: reduce)": {
          animation: "none",
        },
      }}
    />
  );
};
export default EdSpinner;
